import ProductsApi from '../../apis/Product';

export default {
    namespaced: true,
    state: {
        products: [],
        product_response: null,
        product_selected: {},
        product: {}
    },
    mutations: {
        set_products (state, data) {
            state.products = data;
        },
        set_product_response (state, value) {
            state.product_response = value;
        },
        set_product (state, data) {
            state.product = data;
        },
        set_product_selected (state, data) {
            state.product_selected = data;
        }
    },
    actions: {
        setProductSelected ({commit}, data) {
            commit('set_product_selected', data);
        },
        async getAllProducts ({commit}, filters) {
            return await ProductsApi.get_all(filters)
                .then( response => {
                    commit('set_products', response.data);
                })
                .catch( error => {
                    console.log(error);
                })
        },
        async getProduct ({commit}, product_id) {
            return await ProductsApi.get_product(product_id)
                .then( response => {
                    commit('set_product', response.data);
                })
                .catch( error => {
                    console.log(error);
                })
        },
        async getListProducts ({commit}, filters) {
            return await ProductsApi.get_list(filters)
                .then( response => {
                    commit('set_products', response.data);
                })
                .catch( error => {
                    console.log(error);
                })
        },
        async store({commit}, product) {
            commit('set_product_response', null);
            return await ProductsApi.store(product)
                .then( response => {
                    commit('set_product_response', 'success');
                })
                .catch( error => {
                    commit('set_product_response', 'error');
                })
        },
        async update({commit}, product) {
            commit('set_product_response', null);
            return await ProductsApi.update(product)
                .then( response => {
                    commit('set_product_response', 'success');
                })
                .catch( error => {
                    commit('set_product_response', 'error');
                })
        },

    }
}